import React from "react";

interface FormFieldProps {
  htmlFor: string;
  label: string;
  children: React.ReactNode;
}

const FormField: React.FC<FormFieldProps> = ({ htmlFor, label, children }) => {
  return (
    <div className={"w-full"}>
      <label
        htmlFor={htmlFor}
        className="block text-sm font-medium text-gray-700"
      >
        {label}
      </label>
      <div className="mt-1">{children}</div>
    </div>
  );
};

export default FormField;
